import React from "react";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import { Block, BlockHead, BlockHeadContent, BlockTitle, BlockDes } from "../../components/Component";
import { Card, CardBody, CardTitle, CardText, Button, Row, Col } from "reactstrap";
import { useNavigate } from "react-router";

const Tutorials = () => {
    const navigate = useNavigate();
    //Fiv1HMRunDM
    const tutorials = [

        {
            title: "Subaccount system explanation",
            description: "Learn how to efficiently manage your team and how to control subaccount limits.",
            videoUrl: "https://www.youtube.com/embed/fPUEaO963aA",
            serviceUrl: "/dashboard/team"
        },
        {
            title: "BluBubl (TextLink) and GHL",
            description: "Integrate TextLink with GoHighLevel to automate and enhance your messaging workflows.",
            videoUrl: "https://www.youtube.com/embed/iEQxln7P_Uc"
        },
        {
            title: "BluBubl (TextLink) and Make.com",
            description: "Learn how to use TextLink with Make.com to create powerful automation scenarios for your business.",
            videoUrl: "https://www.youtube.com/embed/2OU3KNbn9PY"
        },
        {
            title: "BluBubl (TextLink) and Zapier",
            description: "Integrate TextLink with Zapier to automate and enhance your messaging workflows.",
            videoUrl: "https://www.youtube.com/embed/Owc1V5n9MUE"
        },
    ];

    return (
        <>
            <Head title="Tutorials" />
            <Content>
                {/* Header Section */}
                <Block size="md">
                    <BlockHead>
                        <BlockHeadContent>
                            <BlockTitle tag="h5">Tutorials</BlockTitle>
                            <BlockDes>
                                <p>Explore these step-by-step video tutorials to make the most out of TextLink's features.</p>
                                <br />
                            </BlockDes>
                        </BlockHeadContent>
                    </BlockHead>
                </Block>

                {/* Tutorials Section */}
                <Row className="g-4">
                    {tutorials.map((tutorial, index) => (
                        <Col lg="5" md="12" key={index} className="mb-4">
                            <Card className="card-bordered shadow-sm h-100" style={{ borderRadius: "12px", overflow: "hidden" }}>
                                <div className="ratio ratio-16x9">
                                    <iframe
                                        src={tutorial.videoUrl}
                                        title={tutorial.title}
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowFullScreen
                                        className="card-img-top"
                                        style={{ borderRadius: "0" }}
                                    ></iframe>
                                </div>
                                <CardBody className="card-inner d-flex flex-column">
                                    <CardTitle tag="h4" className="mb-2">{tutorial.title}</CardTitle>
                                    <CardText className="mb-4">{tutorial.description}</CardText>
                                    {tutorial.serviceUrl && (
                                        <div className="mt-auto text-center">
                                            <Button
                                                color="primary"
                                                href={tutorial.serviceUrl}
                                                target="_blank"
                                                className="w-100"
                                                onClick={() => navigate(tutorial.serviceUrl)}
                                            >
                                                Go to Service
                                            </Button>
                                        </div>
                                    )}
                                </CardBody>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Content>
        </>
    );
};

export default Tutorials;
